import { createContext, ReactNode } from "react";

export type ConfirmRequest = {
  title: string;
  message?: ReactNode;
  confirmLabel?: string;
  isDestructive?: boolean;
};

export type PendingConfirmRequest = ConfirmRequest & {
  answer: (confirmed: boolean) => void;
};

export type AskConfirmation = (request: ConfirmRequest) => Promise<boolean>;

export const ConfirmDialogCtx = createContext<AskConfirmation | null>(null);
